import { render, staticRenderFns } from "./InitPage.vue?vue&type=template&id=ad497e6a&"
import script from "./InitPage.vue?vue&type=script&lang=js&"
export * from "./InitPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports